import Button from "@/components/Button";
import { useTranslation } from "next-i18next";
import React from "react";
import clsx from "clsx";
import SafeArea from "@/components/safe-area";
import {
	Drawer,
	DrawerContent,
	DrawerDescription,
	DrawerFooter,
	DrawerHeader,
	DrawerTitle,
	NestedRoot,
} from "@/components/ui/drawer";

import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from "@/components/ui/modal";

import useMobile from "@/hooks/useMobile";

interface Props {
	visible: boolean;
	onClose: () => void;
	title: string | React.ReactNode;
	content: React.ReactNode | string;
	okText?: string;
	onOk?: () => void;
	zIndex?: number;
	align?: "center" | "left";
	nested?: boolean;
	/** 为 false 时不可通过遮罩、ESC、下滑等方式关闭，仅能通过确认按钮 onOk */
	dismissible?: boolean;
}

export default function NoticeModalBottom(props: Props) {
	const { t } = useTranslation("common");
	const isMobile = useMobile();
	const dismissible = props.dismissible !== false;

	const handleOpenChange = (open: boolean) => {
		if (!open && dismissible) {
			props.onClose();
		}
	};

	const handleOK = () => {
		if (props.onOk) {
			props.onOk();
		} else {
			props.onClose();
		}
	};

	const content = () => {
		return (
			<DrawerContent>
				<div className="mx-auto w-full">
					<DrawerHeader>
						<DrawerTitle className="text-center text-xl font-semibold">{props.title}</DrawerTitle>
						<DrawerDescription></DrawerDescription>
					</DrawerHeader>
					<div className="px-4.5 pb-4">
						<div className={clsx("text-sm font-semibold", props.align === "center" ? "text-center" : "text-left")}>
							{props.content}
						</div>
					</div>
					<DrawerFooter className="px-6">
						<Button block onClick={handleOK}>
							{props.okText || t("ok", { ns: "common" })}
						</Button>
						<SafeArea position="bottom" />
					</DrawerFooter>
				</div>
			</DrawerContent>
		);
	};
	console.log("--------------------", isMobile);
	if (!isMobile) {
		return (
			<Dialog open={props.visible} onOpenChange={handleOpenChange}>
				<DialogTrigger asChild className="h-0 overflow-hidden"></DialogTrigger>
				<DialogContent
					className="w-[420px]"
					showClose={false}
					onPointerDownOutside={(e) => !dismissible && e.preventDefault()}
					onEscapeKeyDown={(e) => !dismissible && e.preventDefault()}
				>
					<DialogHeader>
						<DialogTitle className="text-center">{props.title}</DialogTitle>
						<DialogDescription className="h-0 overflow-hidden"></DialogDescription>
					</DialogHeader>

					<div className="px-4.5 pb-4">
						<div className={clsx("text-sm font-semibold", props.align === "center" ? "text-center" : "text-left")}>
							{props.content}
						</div>
					</div>
					<DialogFooter className="px-6">
						<Button block onClick={handleOK}>
							{props.okText || t("ok", { ns: "common" })}
						</Button>
					</DialogFooter>
				</DialogContent>
			</Dialog>
		);
	}

	if (props.nested) {
		return (
			<NestedRoot open={props.visible} dismissible={dismissible} onOpenChange={handleOpenChange}>
				{content()}
			</NestedRoot>
		);
	}

	return (
		<Drawer open={props.visible} dismissible={dismissible} onOpenChange={handleOpenChange}>
			{content()}
		</Drawer>
	);
}
